import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M13.8701 8.4375C13.8701 6.87891 13.0225 5.45703 11.6826 4.66406C10.3154 3.87109 8.64746 3.87109 7.30762 4.66406C5.94043 5.45703 5.12012 6.87891 5.12012 8.4375C5.12012 10.0234 5.94043 11.4453 7.30762 12.2383C8.64746 13.0312 10.3154 13.0312 11.6826 12.2383C13.0225 11.4453 13.8701 10.0234 13.8701 8.4375ZM13.0225 12.9219C12.0381 13.6875 10.8076 14.125 9.49512 14.125C6.35059 14.125 3.80762 11.582 3.80762 8.4375C3.80762 5.32031 6.35059 2.75 9.49512 2.75C12.6123 2.75 15.1826 5.32031 15.1826 8.4375C15.1826 9.77734 14.7178 11.0078 13.9521 11.9922L17.6162 15.6289C17.8623 15.9023 17.8623 16.3125 17.6162 16.5586C17.3428 16.832 16.9326 16.832 16.6865 16.5586L13.0225 12.9219Z"
	})
});
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
